import { Injectable, EventEmitter } from '@angular/core';
import { AppHttpService } from '../app-http.service';

@Injectable()
export class ModalService {
  modalUpdated: EventEmitter<any> = new EventEmitter();
  modal = {
    open: false,
    content: '',
    type: ''
  };

  constructor(private httpService: AppHttpService) {}

  openModal(type) {
    if (type === 'emptyCart') {
      this.modal.content = 'Es wurde noch kein Losangebot ausgewählt.';
      this.modal.open = true;
      this.modal.type = type;
      this.modalUpdated.emit(this.modal);
    } else if (type === 'notLoggedIn') {
      this.modal.content =
        'Der Bestellbetrag inkl. etwaiger Nachzahlung darf maximal 150 € betragen. Bitte passen Sie Ihre Produktauswahl an, oder <a href="/meinkonto/login/?order=true&redirect=' +
        encodeURIComponent(window.location.href) +
        '">loggen Sie sich in das Kundenkonto ein.</a>';
      this.modal.open = true;
      this.modal.type = type;
      this.modalUpdated.emit(this.modal);
    } else {
      this.httpService.getStaticContent(type).subscribe((response) => {
        this.modal.content = response;
        this.modal.open = true;
        this.modalUpdated.emit(this.modal);
      });
    }
  }
}
